import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MarkdownService } from '@services/markdown/markdown.service';
import { Observable } from 'rxjs';


import { DomSanitizer, SafeHtml } from '@angular/platform-browser';


interface BeneficioItem {
  alt: string;
  icon: string;
  iconStyle: string;
  header: string;
  content?: string;
  colClass?: string;
  hideHeaderInMobile?: boolean;
  headerClass?: string;
  details: {
    plus: {
      header: string;
      content?: string;
    };
    silver: {
      header: string;
      content?: string;
    };
    gold: {
      header: string;
      content?: string;
    };
  };
}

@Component({
  selector: 'app-beneficios-categorias',
  templateUrl: './beneficios-categorias.component.html',
  styleUrls: ['./beneficios-categorias.component.scss'],
})
export class BeneficiosCategoriasComponent implements OnInit {
  // private fragment: string;

  beneficiosItems: BeneficioItem[] = [
    {
      alt: 'beneficios-membresía',
      icon: '/assets/img/svg/exoneracionMembresia.svg',
      iconStyle: 'height: 2.9rem;',
      header: 'Por cobro de membresía de S/68',
      details: {
        plus: {
          header:
            'No aplica cobro de membresía por consumos mensuales desde S/250 por 12 meses',
          content:
            'Aplica para todos los clientes que contrataron la tarjeta de crédito desde el 01/12/2024',
        },
        silver: {
          header: '<span>50%</span> Descuento',
          content:
            'Para todos los clientes que contraron la tarjeta de crédito desde el 01/12/2024',
        },
        gold: {
          header: 'No aplica cobro de membresía',
          content:
            'Para todos los clientes que contraron la tarjeta de crédito desde el 01/12/2024',
        },
      },
    },
    {
      alt: 'beneficios-cumpleaños',
      icon: '/assets/img/svg/i-mes-de-cumple.svg',
      iconStyle: 'height: 2.9rem;',
      header: 'Beneficio por mes de cumpleaños',
      content: '<p class="mt-2" style="color: #000000; font-size: 12px;">*TyC en Ver Condiciones de Beneficios</p>',
      details: {
        plus: {
          header:
            '<span>10%</span> dscto. adicional en vestuario seleccionado en Ripley.com y la Ripley App.',
          content:
            'Con el código: <span class="span-despacho">CUMPLEPLUS</span><br>Tope S/25',
        },
        silver: {
          header: '<span>15%</span> dscto. adicional en vestuario seleccionado en Ripley.com y la Ripley App.',
          content:
            'Con el código: <span class="span-despacho">CUMPLESILVER</span><br>Tope S/30',
        },
        gold: {
          header: '<span>20%</span> dscto. adicional en vestuario seleccionado en Ripley.com y la Ripley App.',
          content:
            'Con el código: <span class="span-despacho">CUMPLEGOLD</span><br>Tope S/35',
        },
      },
    },
    {
      alt: 'beneficios-despacho',
      icon: '/assets/img/svg/combinedShape.svg',
      iconStyle: 'height: 1.3rem;',
      header: 'Despacho en Ripley.com.pe',
      content: `<a href="assets/pdf/rpgo-despacho-gratis.pdf" target="_blank" style="font-size: 14px;">Cómo usar mi cupón</a>
      <p class="mt-2" style="color: #000000; font-size: 12px;">Registrate en Ripley.com.pe</p>
                        <p style="color: #000000; font-size: 12px;">48 horas antes de realizar la</p>
                        <p style="color: #000000; font-size: 12px;">compra.</p>
                        <p style="text-align: left;color: black;font-size: 0.8rem;" class="mt-1">*TyC en Ver Condiciones de Beneficios</p>`,
      details: {
        plus: {
          header:
            '<span>S/20</span> dscto. en despacho',
          content:
            `Por compras en Ripley.com.pe ingresando con el código<br><span class="span-despacho">DESPACHOGO</span>
            <br>Por compras superiores a S/149.`,
        },
        silver: {
          header: '<span>2</span> despachos al mes',
          content:`Por compras en Ripley.com.pe ingresando con el código<br><span class="span-despacho">DESPACHOSP</span>
            <br>Tope de descuento S/ 100 por despacho.`,
        },
        gold: {
          header: '<span>3</span> despachos al mes',
          content:`Por compras en Ripley.com.pe ingresando con el código<br><span class="span-despacho">DESPACHOGP</span>
            <br>Tope de descuento S/ 100 por despacho.`,
        },
      },
    },
    {
      alt: 'beneficios-restofans',
      icon: '/assets/img/svg/restofans-beneficios.svg',
      iconStyle: 'height: 1.8rem;',
      header: 'RestoFans',
      content: `<p class="mt-2" style="color: #000000; font-size: 12px;">Máximo 1 dscto por cliente por jueves</p>
      <p style="text-align: left;color: black;font-size: 0.8rem;" class="mt-1">*TyC en Ver Condiciones de Beneficios</p>`,
      details: {
        plus: {
          header:
            '<span>50%</span> dscto.<br>',
          content:
            `Todos los jueves en restaurantes seleccionados en Lima y Provincias. Dscto. máx S/ 100`,
        },
        silver: {
          header: '<span>50%</span> dscto.<br>',
          content:`Todos los jueves en restaurantes seleccionados en Lima y Provincias. Dscto. máx S/ 100`,
        },
        gold: {
          header: '<span>60%</span> dscto.<br>',
          content:`Todos los jueves en restaurantes seleccionados en Lima y Provincias. Dscto. máx S/ 100`,
        },
      },
    },
    {
      alt: 'beneficios-vigencia',
      icon: '/assets/img/svg/i-clock-beneficios.svg',
      iconStyle: 'height: 1.5rem;',
      header: 'Vigencia de Ripley Puntos GO',
      headerClass: 'text-center',
      details: {
        plus: {
          header:
            '<span>12</span> Meses',
        },
        silver: {
          header:
            '<span>12</span> Meses',
        },
        gold: {
          header:
            '<span>24</span> Meses',
        },
      },
    },
    {
      alt: 'beneficios-descuentos',
      icon: '/assets/img/svg/i-benecifios-ticket.svg',
      iconStyle: 'height: 4.0rem;',
      colClass: 'text-center',
      header: 'Descuentos exclusivos en Tiendas Ripley y Ripley.com.pe',
      hideHeaderInMobile: true,
      details: {
        plus: {
          header:
            '<img class="mt-2" src="/assets/img/svg/i-beneficios-star-plus.svg"  alt="i-beneficios-star-plus.svg">',
        },
        silver: {
          header:
            '<img class="mt-2" src="/assets/img/svg/i-beneficios-star-silver.svg"  alt="i-beneficios-star-plus.svg">',
        },
        gold: {
          header:
            '<img class="mt-2" src="/assets/img/svg/i-beneficios-star-gold.svg"  alt="i-beneficios-star-plus.svg">',
        },
      },
    },
    {
      alt: 'beneficios-acumulacion',
      icon: '/assets/img/svg/i-beneficios-shop.svg',
      iconStyle: 'height: 3.5rem;',
      header: 'Acumular Puntos GO en todas tus compras',
      colClass: 'text-center',
      hideHeaderInMobile: true,
      details: {
        plus: {
          header:
            '<img class="mt-2" src="/assets/img/svg/i-beneficios-star-plus.svg"  alt="i-beneficios-star-plus.svg">',
        },
        silver: {
          header:
            '<img class="mt-2" src="/assets/img/svg/i-beneficios-star-silver.svg"  alt="i-beneficios-star-plus.svg">',
        },
        gold: {
          header:
            '<img class="mt-2" src="/assets/img/svg/i-beneficios-star-gold.svg"  alt="i-beneficios-star-plus.svg">',
        },
      },
    },
    {
      alt: 'beneficios-canjes',
      icon: '/assets/img/svg/i-pizza-beneficios.svg',
      iconStyle: 'height: 5.0rem;',
      header: 'Acceder a canje de productos, experiencias, millas y Gift Cards',
      colClass: 'text-center',
      hideHeaderInMobile: true,
      details: {
        plus: {
          header:
            '<img class="mt-2" src="/assets/img/svg/i-beneficios-star-plus.svg"  alt="i-beneficios-star-plus.svg">',
        },
        silver: {
          header:
            '<img class="mt-2" src="/assets/img/svg/i-beneficios-star-silver.svg"  alt="i-beneficios-star-plus.svg">',
        },
        gold: {
          header:
            '<img class="mt-2" src="/assets/img/svg/i-beneficios-star-gold.svg"  alt="i-beneficios-star-plus.svg">',
        },
      },
    },
  ];

  OpenTerminosBeneficios = false;
  href: string = '';
  IsSegmentacion: boolean = false;
  tierSelected: 'plus' | 'silver' | 'gold' = 'plus';

  htmlLegales$: Observable<string>;
  constructor(
    private router: Router,
    private markdownService: MarkdownService,
    private readonly sanitizer: DomSanitizer,
  ) {
    this.href = this.router.url;
    if (this.href != '/segmentacion') {
      this.IsSegmentacion = true;
    }
  }



  setSelectedTier(tier: 'plus' | 'silver' | 'gold'){
    this.tierSelected = tier;
  }


  ngOnInit() {
    // console.log('BeneficiosCategorias');
    // this.fragment = this.activatedRoute.snapshot.fragment;
    // console.log(this.fragment);

    // if (this.fragment != null) {
    //   // console.log('querySelector');
    //   // document.querySelector('#' + this.fragment).scrollIntoView();
    // }
    this.htmlLegales$ = this.markdownService.loadMarkdown(
      'assets/legales/categorias.md',
    );
  }

  btnEnviar() {
    window.location.href =
      'https://www.bancoripley.com.pe/promociones/index.html';
  }

  openDialog() {
    this.OpenTerminosBeneficios = true;
  }

  closeDialog() {
    this.OpenTerminosBeneficios = false;
  }
}
